export default __webpack_public_path__ + "static/media/carts.383a0ed3.png";